// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { FileKind } from "../../../../define/FileKind";
import { GeneralKind } from "../../../../define/GeneralKind";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { SettleLawsuitKind } from "../../../../define/SettleLawsuitKind";
import LevelInfoNode from "../../../../gameCommon/basic/LevelInfoNode";
import NormalGameManager from "../../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitResultLayer extends BasePopUpLayer {

	@property({ type: cc.Label, displayName:'' })
	labelReputation: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelGold: cc.Label = null;
   
    @property(cc.Node)
    levelInfoNode: cc.Node = null;

    private levelInfoScript: LevelInfoNode = null;
    /** 原官阶 */
    protected oriOfficialLv = 0;
    /** 原声望 */
    protected oriReputation = 0;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.levelInfoScript = cc.find('LevelInfoNode', this.levelInfoNode).getComponent(LevelInfoNode);
        // this.addLayerTouchEvent();
        this.initShow();
        this.initLayer();
    }

    initShow() {

    }

    initLayer() {
        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        let officialLv = this.oriOfficialLv = gameData.m_officialLv;
        let reputation = this.oriReputation = gameData.m_reputation;
        // this.oriGoldNum = O1HD.getServices().userSrv.getCoins();

        let expProgressData = CsvDataManage.instance.getExpProgressFromLv(officialLv, reputation);
        if (expProgressData) {
            this.levelInfoScript.refreshExp(
                expProgressData.curExp
                , expProgressData.totalExp
                , expProgressData.bMax
            );
        }

        let bHaveGoods = false;
        let Type = GeneralKind.ValueChangeType;
        for (let o of this._carryData.retArr) {
            let splits = o.split(FileKind.ResParseType.SUB_ITEM);
            let type = splits[0];
            switch(type) {
                case Type.GOLD: {
                    let goldNum = Number(splits[1]);
                    this.labelGold.string = (goldNum > 0 ? '+' : '') + data_control.getNumberFormat(goldNum, 1);
                    O1HD.getServices().userSrv.setCoins(goldNum, true);
                }
                break;
                case Type.GOODS_GET: {
                    bHaveGoods = true;
                    let goodsId = Number(splits[1]);
                    let goodsNum = Number(splits[2] || 1);
                    this.setPropData(goodsId, goodsNum);
                }
                break;
                case Type.PRESTIGE: {
                    let exp = Number(splits[1]);
                    if (exp != 0) {
                        gameManager.addExp(exp);
                        this.labelReputation.string = (exp > 0 ? '+' + exp : exp) + '';
                        let expProgressData = CsvDataManage.instance.getExpProgressFromLv(
                            gameData.m_officialLv, gameData.m_reputation);
                        if (expProgressData) {
                            officialLv = gameData.m_officialLv;
                            // this.levelInfoScript.refreshLevel(curLv);
                            this.levelInfoScript.refreshExp(
                                expProgressData.curExp
                                , expProgressData.totalExp
                                , expProgressData.bMax
                                , true
                            );
                        }
                    }
                }
                break;
            }
        }
        this.levelInfoScript.refreshLevel(officialLv);
        this.showProp(bHaveGoods);
    }

    showProp(visible: boolean) {

    }

    setPropData(id: number, num: number) {

    }

    touchEventEnd(event: cc.Event.EventTouch){
        this.onClickClose();
    }

    onClickClose() {
        this.destroyNode();
        this._carryData.parent.closeLayer();
    }

    // update (dt) {}
}
